import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { tInvtModelOnHand } from "src/app/models/tInvtModel";
import { AppSettings } from "src/app/shared/AppSettings";

import { InsertApplyTempLetterModel,tSelectionModel,tSelectionAnsModel,editApplyTempLetterModel,tApplyTempLetterModel} from 'src/app/models/tempLetter/tempLetterFormModel';

import { tShopService } from "src/app/services/tShop.service";
import { NavigationComponent } from "src/app/pages/navigation/navigation.component";
import { AngularEditorConfig } from '@kolkov/angular-editor';
export class letterPreviewModel {
  patient: {
    name_cn: string;
    name_en: string;
    gender: string;
    dob: string;
  };
  date: string;
  toAddress:string;
  employee: string;
  remark1: string;
  remark2: string;
  remark3: string;
  remark4: string;
  remark5: string;
  remark6: string;
  letter: { id: number; title_cn: string; title_en: string };
}
@Component({
  selector: "app-letters",
  templateUrl: "./letters.component.html",
  styleUrls: ["./letters.component.css"],
})
export class LettersComponent implements OnInit {



  config: AngularEditorConfig = {
    editable: false,
    spellcheck: true,
    height: '99%',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    sanitize:false,
    showToolbar:false,
    enableToolbar:false,
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };







  
  picFullPath = AppSettings.shopAdapter.imagePath + "/assets/img/print/doc_logo.png";

  letter2 = false;
  letter3 = false;

  haveSelection=true;

  TTremark1: "TTremark1";
  TTremark2: "TTremark2";
  TTremark3: "TTremark3";

  TTremark4: "TTremark4";
  TTremark5: "TTremark5";
  TTremark6: "TTremark6";
  shopAddressEng1 = "";
  shopAddressEng2 = "";
  shopAddressEng3 = "";
  shopName="";
  shopAddress1 = "";
  shopAddress2 = "";
  shopAddress3 = "";
  letterTitle="";
  letterTitleENG="";
  freeTextTitle1="";
  freeTextTitle2="";
  freeTextTitle3="";
  freeTextTitle4="";
  freeTextTitle5="";
  freeTextTitle6="";
  @Input() id: number;
  @Input() data:letterPreviewModel;
  @Input() tSelection:tSelectionModel[];
  @Input() tApplyTempLetter:tApplyTempLetterModel;

  treatments = [
    "消痛治療 Pain Management",
    "肌肉及骨骼復康 Orthopaedics Rehabilitation",
    "運動創傷復康 Sports Injury Rehabilitation",
    "工傷意外復康服務 Work Injury Rehabilitaiton",
    "神經科復康 Neurological Rehabilitation",
    "運動療法 Exercise Therapy",
    "針灸 Acupuncture",
    "運動體能提升 Sports Function Enhancement",
  ];




  constructor(
    public activeModal: NgbActiveModal,
    private tShopService: tShopService,
  ) {}

  ngOnInit() {
    this.getShopInfo(NavigationComponent.selectedShopID.toString());
    console.table(this.data);
    console.log('id = ',this.id);
    if(this.id === 2) this.letter2 = true;
    if(this.id === 3) this.letter3 = true;

    if(this.tSelection==null || this.tSelection.length==0){
      this.haveSelection=false;
      console.log("have selection"+this.haveSelection);
    }else{
      this.haveSelection=true;
      console.log("have selection"+this.haveSelection);
    }

    this.letterTitle=this.tApplyTempLetter.letterName;
    this.letterTitleENG=this.tApplyTempLetter.letterNameEng;
    this.freeTextTitle1=this.tApplyTempLetter.freeTextTitle1;
    this.freeTextTitle2=this.tApplyTempLetter.freeTextTitle2;
    this.freeTextTitle3=this.tApplyTempLetter.freeTextTitle3;
    this.freeTextTitle4=this.tApplyTempLetter.freeTextTitle4;
    this.freeTextTitle5=this.tApplyTempLetter.freeTextTitle5;
    this.freeTextTitle6=this.tApplyTempLetter.freeTextTitle6;

    this.data.remark1=this.data.remark1.replace('border="1"', 'border="0"');

      //shand[0].style.cssText="height: auto; min-height: 5rem;border:0px;";
      //console.log(shand[0].style.cssText);

      setTimeout(()=>{     
        let editorStyle = document.getElementsByClassName("angular-editor-textarea");
       // console.log(shand);                  // <<<---using ()=> syntax

        for (let index = 0; index < editorStyle.length; ++index) {
          editorStyle[index].setAttribute("style", "border:0px; resize:none; height:auto");
      }
    }, 500);
  }


  autoResize(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  getShopInfo(shopID: string) {
    this.tShopService.getDataById(shopID).subscribe(
      (res: any) => {
        this.shopAddressEng1 = res.shopAddressEng1;
        this.shopAddressEng2 = res.shopAddressEng2;
        this.shopAddressEng3 = res.shopAddressEng3;
        this.shopAddress1 = res.shopAddress1;
        this.shopAddress2 = res.shopAddress2;
        this.shopAddress3 = res.shopAddress3;
        this.shopName=res.shopName;
        // this.shopFax=res.shopFax;
        // this.shopList = res;
        // this.shopName = this.shopList[0].shopName.toString();
        // console.log('shopList = ' + JSON.stringify(res));
        // console.log('shopList = ' + this.shopList[0].shopName.toString());
      },
      (err) => {
        console.log(err);
      }
    );
  }


}
